import { render, staticRenderFns } from "./castAbout.vue?vue&type=template&id=717514e3&scoped=true&"
import script from "./castAbout.vue?vue&type=script&lang=js&"
export * from "./castAbout.vue?vue&type=script&lang=js&"
import style0 from "./castAbout.vue?vue&type=style&index=0&id=717514e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717514e3",
  null
  
)

export default component.exports